/** Deterministic gradient for custom app launcher tiles (no DB column). */
const PALETTES = [
  { bg: "linear-gradient(145deg, #ede9fe 0%, #ddd6fe 100%)", fg: "#5b21b6", ring: "rgba(124, 58, 237, 0.35)" },
  { bg: "linear-gradient(145deg, #e0f2fe 0%, #bae6fd 100%)", fg: "#075985", ring: "rgba(2, 132, 199, 0.35)" },
  { bg: "linear-gradient(145deg, #fce7f3 0%, #fbcfe8 100%)", fg: "#9d174d", ring: "rgba(219, 39, 119, 0.35)" },
  { bg: "linear-gradient(145deg, #fef3c7 0%, #fde68a 100%)", fg: "#92400e", ring: "rgba(217, 119, 6, 0.4)" },
  { bg: "linear-gradient(145deg, #d1fae5 0%, #a7f3d0 100%)", fg: "#065f46", ring: "rgba(5, 150, 105, 0.35)" },
];

function hashStr(s) {
  let h = 0;
  const str = String(s || "");
  for (let i = 0; i < str.length; i += 1) h = (h << 5) - h + str.charCodeAt(i);
  return Math.abs(h);
}

export function swatchForAppKey(key) {
  return PALETTES[hashStr(key) % PALETTES.length];
}
